module.exports = [
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 4.13
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 3.07
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 2.47
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 2.93
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 2.93
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 4.3
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 3.9
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 4.3
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 4.17
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 4.27
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 4.57
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 4.93
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 5.67
  },
  {
    "COD": "Alcoholic Liver Disease",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 6
  }
]
